









































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import fieldData from "@/ts/FormData";
import AddressInfo from '@/views/shared/AddressInfo.vue';
import api from "@/ts/functions";
import { IVueStateCollection } from "@/ts/FormBuilder";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import ReportingPeriod from '@/views/reporting/ReportingPeriod.vue';
import { ICCDDActivitiesVueModel } from "@/ts/models/ICCDDActivitiesVueModel";
import VueSimpleSuggest from 'vue-simple-suggest/dist/cjs';


@Component({
    props: {
        form: {
            type: Object as () => ICCDDActivitiesVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        AddressInfo, ReportingPeriod, VueSimpleSuggest
    }
})
export default class CCDDActivitiesFacilityInfo extends Vue {
    name: string = "CCDDActivitiesFacilityInfo";
    title: string = "";

    errorMsgs = ErrorMessages;
    unitsOfMeasure = fieldData.unitsOfMeasure;

    hasAddressError: boolean = false;
    isReportingPeriodError: boolean = false;
    facilities: any = null;
    facilitiesDb: any = null;
    disableFacility: boolean = true;
    facility: any = null;

    mounted() {
        this.title = this.$props.vueStates.views[0].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 0);

        api.getFacilities("CCDD")
            .then(res => {
                this.facilitiesDb = res;
                this.facilitiesDb = this.facilitiesDb.data;
                this.facilities = this.facilitiesDb.map((f: any) => f.facilityName);
                this.facilities = this.facilities.map(Function.prototype.call, String.prototype.trim);
            });

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[0].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[0].visited = true;

        this.$watch("form.facilityNameSelect", (n, o) => {
            if (this.facilitiesDb == null) {
                return;
            }

            var objectId = this.$props.form.facilityNameSelect.substring(this.$props.form.facilityNameSelect.lastIndexOf('-') + 2);

            var facilityAddress = null;

            this.facility = this.facilitiesDb.find((f: any) => f.objectId == objectId);

            if (this.facility == null) {
                facilityAddress = fieldData.emptyAddress[0];
            } else {
                this.$props.form.facilityName = this.facility.facilityName;
                facilityAddress = this.facility.address;
            }
            if (facilityAddress != null) {
                this.$props.form.facilityAddress = facilityAddress;
                if (facilityAddress != fieldData.emptyAddress[0] && this.facility != null) {
                    this.$props.form.facilityId = this.facility.objectId;
                }
            } else {
                //this.$props.form.facilityAddress = fieldData.emptyAddress[0];
            }
        }, { immediate: true });
    }


    get isFacilityNameError(): boolean {

        return func.isNullOrEmpty(this.$props.form.facilityName)
    }

    get isReportingYearError(): boolean {
        return this.$props.form.reportingPeriod == null
    }

    get hasErrors(): boolean {
        return this.isFacilityNameError || this.hasAddressError || this.isReportingPeriodError || this.isReportingYearError;
    }
}
